import {TabList} from "../../common/TabList.js";
export const handleStickySwitchElement = (contentElement) => {
  const menu = contentElement.querySelector(".sticky-switch__menu");
  const tabs = new TabList(contentElement.querySelectorAll(".sticky-switch__content"));
  const updateMenuButton = (menu2, id) => {
    menu2.querySelectorAll("button.sticky-switch__menu-button").forEach((button) => {
      button.classList.remove("is-active");
      if (button.dataset.stickySwitchTab === id) {
        button.classList.add("is-active");
        window.location.hash = button.dataset.tabUid;
      }
    });
  };
  const updateMenuButtonByHash = (menu2, activeHash) => {
    menu2.querySelectorAll("button.sticky-switch__menu-button").forEach((button) => {
      button.classList.remove("is-active");
      if (button.dataset.tabUid === activeHash) {
        button.classList.add("is-active");
        tabs.showTab(button.dataset.stickySwitchTab);
      }
    });
  };
  menu.querySelectorAll("button.sticky-switch__menu-button").forEach((button) => {
    button.addEventListener("click", () => {
      updateMenuButton(menu, button.dataset.stickySwitchTab);
      tabs.showTab(button.dataset.stickySwitchTab);
    });
  });
  if (window.location.hash && window.location.hash.startsWith("#tc")) {
    updateMenuButtonByHash(menu, window.location.hash.slice(1));
  }
  const handleScroll = () => {
    if (!menu)
      return;
    if (window.innerWidth >= 1024) {
      const scrollableHeight = document.body.scrollHeight - window.innerHeight;
      const targetScrollPos = scrollableHeight * 0.9;
      menu.style.opacity = window.scrollY > targetScrollPos ? "0" : "1";
    } else {
      menu.style.opacity = "1";
    }
  };
  window.addEventListener("scroll", handleScroll);
};
